"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskTargetsContextProvider = void 0;
var React = require("react");
var urls_1 = require("../../urls");
var matrixUtils_1 = require("../../components/admin/matrixUtils");
var MatrixColorSvc_1 = require("../../services/MatrixColorSvc");
var initialState = {
    risk_targets: [],
    availableRiskColorChoices: [],
    availableOppColorChoices: [],
    selectedRiskColor: null,
    selectedOppColor: null,
    availableMatrixOriginChoices: [],
    availableMatrixOrientationChoices: [],
    availableLikelihoodChoices: []
};
var RiskTargetsContext = React.createContext(__assign(__assign({}, initialState), { fetchRiskColorChoices: undefined, fetchOppColorChoices: undefined, fetchRiskTargets: undefined, createRiskTarget: undefined, createMatrix: undefined, deleteRiskTarget: undefined, deleteMatrix: undefined, duplicateRiskTarget: undefined, onSaveRiskTarget: undefined, onChangeRiskTarget: undefined, onMoveRiskTargetUp: undefined, onMoveRiskTargetDown: undefined, onChangeMatrixConsequence: undefined, onChangeMatrixFrequency: undefined, onChangeMatrixCell: undefined, onChangeMatrix: undefined, onChangeColorSelector: undefined, onClickCell: undefined, fetchMatrixOriginChoices: undefined, fetchMatrixOrientationChoices: undefined, fetchMatrixLikelihoodChoices: undefined }));
exports.default = RiskTargetsContext;
var RiskTargetsContextProvider = (function (_super) {
    __extends(RiskTargetsContextProvider, _super);
    function RiskTargetsContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, initialState);
        var self = _this;
        document.addEventListener("number_of_colors_changed", function () {
            self.fetchRiskColorChoices();
            self.fetchOppColorChoices();
        });
        return _this;
    }
    RiskTargetsContextProvider.prototype.fetchRiskColorChoices = function () {
        var self = this;
        var url = (0, urls_1.resolve)(urls_1.Urls.admin_risktargets_riskcolorchoices, this.props.project_id);
        return $.ajax(url, {
            type: "GET",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                var convertedData = response.results.map(function (item) {
                    return ({
                        display_name: item.label,
                        value: item.id,
                        color: item.color,
                    });
                });
                if (response.success) {
                    self.setState({
                        selectedRiskColor: parseInt(convertedData[0].value),
                        availableRiskColorChoices: convertedData,
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.fetchOppColorChoices = function () {
        var self = this;
        var url = (0, urls_1.resolve)(urls_1.Urls.admin_risktargets_opportunitycolorchoices, this.props.project_id);
        return $.ajax(url, {
            type: "GET",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                var convertedData = response.results.map(function (item) {
                    return ({
                        display_name: item.label,
                        value: item.id,
                        color: item.color,
                    });
                });
                if (response.success) {
                    self.setState({
                        selectedOppColor: parseInt(convertedData[0].value),
                        availableOppColorChoices: convertedData,
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.fetchRiskTargets = function () {
        var self = this;
        var url = (0, urls_1.resolve)(urls_1.Urls.admin_risktargets, this.props.project_id);
        return $.ajax(url, {
            type: "GET",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    self.setState({
                        risk_targets: response.results,
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.createRiskTarget = function () {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_create_risktarget, this.props.project_id), {
            type: "POST",
            data: {},
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success && response.created) {
                    self.setState(function (prev) { return ({
                        risk_targets: [response.created].concat(prev.risk_targets)
                    }); });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.createMatrix = function (riskTarget, is_opportunity) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_create_matrix, this.props.project_id, riskTarget.id), {
            type: "POST",
            data: JSON.stringify({
                is_opportunity: is_opportunity
            }),
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success && response.created) {
                    self.setState(function (prev) {
                        riskTarget.matrices = (riskTarget.matrices || []).concat([response.created]);
                        return {
                            risk_targets: prev.risk_targets,
                        };
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.deleteRiskTarget = function (riskTarget) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_remove_risktarget, this.props.project_id, riskTarget.id), {
            type: "DELETE",
            complete: ajaxErrorHandler,
            success: function () {
                self.fetchRiskTargets();
            }
        });
    };
    RiskTargetsContextProvider.prototype.deleteMatrix = function (riskTarget, matrix) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_remove_matrix, this.props.project_id, matrix.id), {
            type: "DELETE",
            complete: ajaxErrorHandler,
            success: function () {
                self.fetchRiskTargets();
            }
        });
    };
    RiskTargetsContextProvider.prototype.duplicateRiskTarget = function (riskTarget) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_copy_riskarget, this.props.project_id, riskTarget.id), {
            type: "POST",
            complete: ajaxErrorHandler,
            success: function () {
                self.fetchRiskTargets();
            }
        });
    };
    RiskTargetsContextProvider.prototype.onSaveRiskTarget = function (riskTarget) {
        var newRiskTarget = __assign({}, riskTarget);
        newRiskTarget.matrices = riskTarget.matrices.map(matrixUtils_1.deepCopyMatrix);
        var self = this;
        var data = {
            risk_target: newRiskTarget,
        };
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_risktargets, this.props.project_id), {
            type: "POST",
            data: JSON.stringify(data),
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    self.fetchRiskTargets();
                }
            }
        }).done(function () {
            setTimeout(function () {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#risktarget_wrapper_" + data.risk_target.id.toString()).offset().top - $(".sticky-top-ie").height()
                }, 500);
            }, 1000);
        });
    };
    RiskTargetsContextProvider.prototype.renewState = function () {
        this.setState(function (prev) { return ({
            risk_targets: prev.risk_targets
        }); });
    };
    RiskTargetsContextProvider.prototype.onChangeRiskTarget = function (riskTarget, attr, value) {
        riskTarget[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onMoveRiskTargetUp = function (riskTarget) {
        var _this = this;
        $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_risktargets_move_up, this.props.project_id, riskTarget.id), {
            type: "POST",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    _this.fetchRiskTargets();
                }
            }
        });
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onMoveRiskTargetDown = function (riskTarget) {
        var _this = this;
        $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_risktargets_move_down, this.props.project_id, riskTarget.id), {
            type: "POST",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    _this.fetchRiskTargets();
                }
            }
        });
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeMatrixConsequence = function (consequence, attr, value) {
        consequence[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeMatrixFrequency = function (frequency, attr, value) {
        frequency[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeMatrixCell = function (cell, attr, value) {
        cell[attr] = value;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.onChangeMatrix = function (matrix, attr, value) {
        matrix[attr] = value;
        this.renewState();
        $("#direction_arrow_" + matrix.id.toString()).css("transform", (0, MatrixColorSvc_1.arrow_direction)(matrix.origin));
        this.onSaveRiskTarget(this.state.risk_targets.find(function (risk_target) { return risk_target.id === matrix.risk_target; }));
    };
    RiskTargetsContextProvider.prototype.onChangeColorSelector = function (color, is_opportunity) {
        if (is_opportunity)
            this.setState({ selectedOppColor: parseInt(color) });
        else
            this.setState({ selectedRiskColor: parseInt(color) });
    };
    RiskTargetsContextProvider.prototype.onClickCell = function (matrix, cell) {
        cell.color = matrix.is_opportunity ? this.state.selectedOppColor : this.state.selectedRiskColor;
        this.renewState();
    };
    RiskTargetsContextProvider.prototype.fetchMatrixOriginChoices = function () {
        var self = this;
        var url = (0, urls_1.resolve)(urls_1.Urls.admin_risktargets_matrixoriginchoices, this.props.project_id);
        return $.ajax(url, {
            type: "GET",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    self.setState({
                        availableMatrixOriginChoices: response.results,
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.fetchMatrixOrientationChoices = function () {
        var self = this;
        var url = (0, urls_1.resolve)(urls_1.Urls.admin_risktargets_matrixorientationchoices, this.props.project_id);
        return $.ajax(url, {
            type: "GET",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    self.setState({
                        availableMatrixOrientationChoices: response.results,
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.fetchMatrixLikelihoodChoices = function () {
        var self = this;
        var url = (0, urls_1.resolve)(urls_1.Urls.admin_risktargets_matrixlikelihoodchoices, this.props.project_id);
        return $.ajax(url, {
            type: "GET",
            contentType: "application/json",
            complete: ajaxErrorHandler,
            success: function (response) {
                if (response.success) {
                    self.setState({
                        availableLikelihoodChoices: response.results,
                    });
                }
            }
        });
    };
    RiskTargetsContextProvider.prototype.render = function () {
        return (React.createElement(RiskTargetsContext.Provider, { value: __assign(__assign({}, this.state), { fetchRiskColorChoices: this.fetchRiskColorChoices.bind(this), fetchOppColorChoices: this.fetchOppColorChoices.bind(this), fetchRiskTargets: this.fetchRiskTargets.bind(this), createRiskTarget: this.createRiskTarget.bind(this), createMatrix: this.createMatrix.bind(this), deleteRiskTarget: this.deleteRiskTarget.bind(this), deleteMatrix: this.deleteMatrix.bind(this), duplicateRiskTarget: this.duplicateRiskTarget.bind(this), onSaveRiskTarget: this.onSaveRiskTarget.bind(this), onChangeRiskTarget: this.onChangeRiskTarget.bind(this), onChangeMatrixConsequence: this.onChangeMatrixConsequence.bind(this), onChangeMatrixFrequency: this.onChangeMatrixFrequency.bind(this), onChangeMatrixCell: this.onChangeMatrixCell.bind(this), onChangeMatrix: this.onChangeMatrix.bind(this), onMoveRiskTargetUp: this.onMoveRiskTargetUp.bind(this), onMoveRiskTargetDown: this.onMoveRiskTargetDown.bind(this), onChangeColorSelector: this.onChangeColorSelector.bind(this), onClickCell: this.onClickCell.bind(this), fetchMatrixOriginChoices: this.fetchMatrixOrientationChoices.bind(this), fetchMatrixOrientationChoices: this.fetchMatrixOriginChoices.bind(this), fetchMatrixLikelihoodChoices: this.fetchMatrixLikelihoodChoices.bind(this) }) }, this.props.children));
    };
    return RiskTargetsContextProvider;
}(React.Component));
exports.RiskTargetsContextProvider = RiskTargetsContextProvider;
